import { useShopifyCookies } from '@shopify/hydrogen-react';
import { shopifyAnalyticsConfig } from '../../data/shopify';

/**
 * Sets Shopify's visitor/session cookies (_shopify_y, _shopify_s) on the root domain so a
 * visitor on m1.marineforceled.com is the same visitor when they reach shop.marineforceled.com.
 * Rendered only when Shopify Analytics is configured.
 */
export function ShopifyCookies() {
  useShopifyCookies({
    hasUserConsent: true,
    domain: shopifyAnalyticsConfig.cookieDomain
  });
  return null;
}